import { Controller } from "@hotwired/stimulus";

const lastWorkspaceStorageKey = "workstream.lastWorkspaceSlug";

export default class extends Controller<HTMLInputElement> {
  connect() {
    const lastWorkspace = window.localStorage.getItem(lastWorkspaceStorageKey);
    if (lastWorkspace) this.element.value = lastWorkspace;
  }
}
